import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-loginwebapp',
    templateUrl: './loginwebapp.component.html',
    standalone: true,
    imports: [RouterOutlet]
})
export class LoginwebappComponent {

}
